import { Box, Button, CircularProgress, MenuItem, Stack, TextField, Typography, useTheme } from '@mui/material';
import SetupSection from './SetupSection';
import { useProductPreview } from './productPreviewContext';

interface MatchFieldsProps {
  marketplaceLabel: string;
  description: string;
  sourceFields: { path: string; label: string }[];
  mapping: { sourceField: string; targetField: string };
  targetOptions: { value: string; label: string }[];
  onSourceChange: (sourceField: string) => void;
  onTargetChange: (targetField: string) => void;
}

const MatchFields = ({
  marketplaceLabel,
  description,
  sourceFields,
  mapping,
  targetOptions,
  onSourceChange,
  onTargetChange,
}: MatchFieldsProps) => {
  const theme = useTheme();
  const preview = useProductPreview();

  return (
  <SetupSection
    title="Match products"
    description={description}
  >
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="flex-end">


      <Stack direction="column" spacing={1} flex={1} alignItems="flex-start">
        <Typography variant="body2" color="text.secondary">{marketplaceLabel}</Typography>
        <TextField select size="small" value={mapping.sourceField} onChange={event => onSourceChange(event.target.value)} sx={{ flex: 1 }} fullWidth>
          {sourceFields.map(field => (
            <MenuItem key={field.path} value={field.path}>{field.label}</MenuItem>
          ))}
        </TextField>
      </Stack>


      <Stack direction="row" spacing={1} p={1.5} alignItems="center">
        <Typography variant="body2" color="text.secondary">Link to</Typography>
      </Stack>

      <Stack direction="column" spacing={1} flex={1} alignItems="flex-end">
        <Typography variant="body2" color="text.secondary">JustStock</Typography>
        <TextField select size="small" value={mapping.targetField} onChange={event => onTargetChange(event.target.value)} sx={{ flex: 1 }} fullWidth>
          {targetOptions.map(option => (
            <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
          ))}
        </TextField>
      </Stack>
    </Stack>

    {preview?.showNothingToImport && (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          py: 1.5,
          px: 2,
          borderRadius: 1,
          bgcolor: theme.palette.error.main,
          color: theme.palette.common.white,
        }}
      >
        <Typography variant="body2" sx={{ flex: 1, color: 'inherit' }}>
          No products found in this preview to import.
        </Typography>
        {preview.hasMore && (
          <Button size="small" onClick={preview.loadMore} disabled={preview.loading} color="inherit">
            {preview.loading ? <CircularProgress size={16} color="inherit" /> : 'Load more'}
          </Button>
        )}
      </Box>
    )}
  </SetupSection>
  );
};

export default MatchFields;
